import {
  Box,
  Button,
  Container,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material'
import { useTranslation } from 'react-i18next'

import heroImage from '@app/assets/hero-bg.png'
import { LinkBehavior } from '@app/components/LinkBehavior'
import { useAuth } from '@app/context/auth'
import { useKnowledgeHubUrl } from '@app/hooks/useKnowledgeHubUrl'

import { RegisterCertificatePanel } from '../RegisterCertificatePanel/RegisterCertificatePanel'

export const Hero = () => {
  const { t } = useTranslation('pages', { keyPrefix: 'welcome.hero' })
  const theme = useTheme()

  const { activeCertificates, verified } = useAuth()

  const isMobile = useMediaQuery(theme.breakpoints.down('md'))

  const isCertified = Number(activeCertificates?.length) > 0
  const khUrl = useKnowledgeHubUrl()

  return (
    <>
      <Box
        py={6}
        px={3}
        sx={{
          backgroundImage: `url(${heroImage})`,
          backgroundSize: 'cover',
          height: {
            md: !isCertified ? 450 : 396,
          },
        }}
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          sx={{
            transform: { lg: `translateY(${isCertified ? '0' : '-10%'})` },
          }}
        >
          <Typography
            variant="h1"
            color="white"
            mb={1}
            fontWeight={500}
            fontFamily="Poppins"
            textAlign="center"
            sx={{ fontSize: '2.5rem' }}
          >
            {t('title')}
          </Typography>
          <Typography color="rgba(255, 255, 255, 0.5)" textAlign="center">
            {t('subtitle')}
          </Typography>
          <Box display={'flex'} flexDirection={'column'} gap={2}>
            <Button
              variant="contained"
              color="turqoise"
              fullWidth
              LinkComponent={LinkBehavior}
              href={khUrl}
              sx={{
                height: 60,
                mt: 4,
                textAlign: 'center',
                fontWeight: 'bold',
                fontSize: {
                  xs: 18,
                  md: 24,
                },
              }}
            >
              {t('access-knowledge-hub')}
            </Button>

            <Stack direction="row" spacing={2}>
              <Button
                size={isMobile ? 'medium' : 'large'}
                href={
                  verified
                    ? isCertified
                      ? '/courses'
                      : '/profile/edit'
                    : '/verify'
                }
                LinkComponent={LinkBehavior}
                color="lime"
                variant="contained"
                sx={{ textAlign: 'center' }}
              >
                {isCertified
                  ? t('view-courses-label')
                  : t('register-certificate-label')}
              </Button>
              <Button
                href={verified ? '/profile' : '/verify'}
                variant="contained"
                size={isMobile ? 'medium' : 'large'}
                LinkComponent={LinkBehavior}
                sx={{
                  boxShadow: 0,
                  bgcolor: 'rgba(255, 255, 255, 0.1)',
                  ':hover': { bgcolor: 'rgba(255, 255, 255, 0.05)' },
                  textAlign: 'center',
                }}
              >
                {t('view-profile-label')}
              </Button>
              <Button
                href={import.meta.env.VITE_WELCOME_PAGE_URL}
                variant="contained"
                size={isMobile ? 'medium' : 'large'}
                LinkComponent={LinkBehavior}
                sx={{ textAlign: 'center' }}
                color="purple"
              >
                {t('help-center-label')}
              </Button>
            </Stack>
          </Box>
        </Box>
      </Box>

      {!isCertified ? (
        <Container
          sx={{
            transform: { lg: 'translateY(-74px)' },
            mt: { xs: 5, lg: 0 },
            width: {
              lg: 983,
            },
          }}
        >
          <RegisterCertificatePanel />
        </Container>
      ) : null}
    </>
  )
}
